<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idInformeInter" class="form-label">IdInformeInter</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInformeInter" name="idInformeInter" v-model="datoInformeInter.idInformeInter" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idInterconsulta" class="form-label"> Interconsulta</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInformeInter.idInterconsulta">
                      <option v-for="interconsulta in interconsultas" :value="interconsulta.idInterconsulta" :key="interconsulta.idInterconsulta">
                        {{ interconsulta.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="cuadro" class="form-label">Cuadro</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInformeInter.cuadro" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="resumen" class="form-label">Resumen</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="resumen" name="resumen" v-model="datoInformeInter.resumen" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="planDiag" class="form-label">PlanDiag</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="planDiag" name="planDiag" v-model="datoInformeInter.planDiag" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="planTera" class="form-label">PlanTera</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="planTera" name="planTera" v-model="datoInformeInter.planTera" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoInformeInter.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="rechaAct" class="form-label">RechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="rechaAct" name="rechaAct" v-model="datoInformeInter.rechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarInformeInter" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInformeInter" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdMedInter</th>
          <th scope="col">IdInformeInter</th>
          <th scope="col">IdElemento</th>
          <th scope="col">IdDosis</th>
          <th scope="col">IdFrecuencia</th>
          <th scope="col">Duracion</th>
          <th scope="col">Indicacion</th>
          <th scope="col">Observación</th>
          <th scope="col">Estado</th>
          <th scope="col">DosisNombre</th>
          <th scope="col">InformeInterFechaReg</th>
          <th scope="col">FrecuenciaNombre</th>
          <th scope="col">ElementoNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="medinter in datosPaginados" :key="medinter.idMedInter">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(medinter.idMedInter)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(medinter.idMedInter)" title="Editar">edit_square</i></td>
          <td>{{medinter.idMedInter}}</td>
          <td>{{medinter.idInformeInter}}</td>
          <td>{{medinter.idElemento}}</td>
          <td>{{medinter.idDosis}}</td>
          <td>{{medinter.idFrecuencia}}</td>
          <td>{{medinter.duracion}}</td>
          <td>{{medinter.indicacion}}</td>
          <td>{{medinter.observacion}}</td>
          <td>{{medinter.estado}}</td>
          <td>{{medinter.dosisNombre}}</td>
          <td>{{getFormattedDate(medinter.informeInterFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{medinter.frecuenciaNombre}}</td>
          <td>{{medinter.elementoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteInformeInter(medinter.idMedInter)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idMedInter" class="form-label">IdMedInter</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedInter" name="idMedInter" v-model="datoMedInter.idMedInter" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idInformeInter" class="form-label">IdInformeInter</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idInformeInter" name="idInformeInter" v-model="datoMedInter.idInformeInter" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoMedInter.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idDosis" class="form-label"> Dosis</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idDosis" name="idDosis" v-model="datoMedInter.idDosis">
                      <option v-for="dosis in dosiss" :value="dosis.idDosis" :key="dosis.idDosis">
                        {{ dosis.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idFrecuencia" class="form-label"> Frecuencia</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idFrecuencia" name="idFrecuencia" v-model="datoMedInter.idFrecuencia">
                      <option v-for="frecuencia in frecuencias" :value="frecuencia.idFrecuencia" :key="frecuencia.idFrecuencia">
                        {{ frecuencia.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="duracion" class="form-label">Duracion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="duracion" name="duracion" v-model="datoMedInter.duracion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="indicacion" class="form-label">Indicacion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="indicacion" name="indicacion" v-model="datoMedInter.indicacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoMedInter.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedInter" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedInter" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      informeinters : [],
      datoInformeInter : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idInformeInter: '',
      interconsultas : [],
// Variables master
// Variables details
      medinters : [],
      datoMedInter : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      informeInters : [],
      elementos : [],
      dosiss : [],
      frecuencias : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idInformeInter = this.$route.params.p_idinformeinter
    this.abrirEditar(this.p_idInformeInter)
    this.getDataPagina(this.paginaActual)
    this.fetchInterconsultas()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idInterconsulta'
        ,'cuadro'
        ,'resumen'
        ,'planDiag'
        ,'planTera'
        ,'rechaAct'
      ];
      const requiredFieldsText = [
        'idInterconsulta'
        ,'cuadro'
        ,'resumen'
        ,'planDiag'
        ,'planTera'
        ,'rechaAct'
      ];
      return validarForm(this.datoInformeInter, requiredFields, requiredFieldsText);
    },
    async guardarInformeInter(){
      if(this.validarForm() === 1){
        try {
          await api.post('/informeinters', this.datoInformeInter)
          swal("Correcto!", "InformeInter creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditInformeInter(){
      if(this.validarForm() === 1){
        try {
          await api.post('/informeinters', this.datoInformeInter)
          swal("Correcto!", "InformeInter creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoInformeInter={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idInformeInter){
      this.modalWindow = true
      if(idInformeInter != null){    
           api.get('/vwinformeinters/'+idInformeInter).then(resp=>{
          this.datoInformeInter = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarInformeInter(){
      this.$router.push('/InformeInter')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.medinters.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmedinters/nombre/'+this.nombreBusqueda).then(response=>{
          this.medinters=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.medinters.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmedinters').then(response=>{
      this.medinters=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.medinters.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idInterconsulta'
        ,'cuadro'
        ,'resumen'
        ,'planDiag'
        ,'planTera'
        ,'rechaAct'
      ];
      const requiredFieldsText = [
        'idInterconsulta'
        ,'cuadro'
        ,'resumen'
        ,'planDiag'
        ,'planTera'
        ,'rechaAct'
      ];
      return validarForm(this.datoInformeInter, requiredFields, requiredFieldsText);
    },
    async guardarMedInter(){
      if(this.validarForm() === 1){
        try {
          this.datoMedInter.idInformeInter = this.datoInformeInter.idInformeInter;
          await api.post('/medinters', this.datoMedInter)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "MedInter creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedInter(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medinters', this.datoMedInter)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "MedInter creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoMedInter={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idMedInter){
      this.modalWindow = true
      if(idMedInter != null){    
           api.get('/vwmedinters/'+idMedInter).then(resp=>{
          this.datoMedInter = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idMedInter){
      this.modalWindow = true
      if(idMedInter != null){
        this.$router.push('/medintermd/'+idMedInter)
      }
    },
    async deleteMedInter (idMedInter) {
      try{
        await api.delete('/medinters/'+idMedInter)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchInterconsultas() {
      fetch('http://localhost:8080/api/v1/interconsultas')
        .then(response => response.json())
        .then(data => {
          this.interconsultas = data;
        })
        .catch(error => {
          console.error('Error fetching interconsultas:', error);
        });
    },
    fetchInformeInters() {
      fetch('http://localhost:8080/api/v1/informeinters')
        .then(response => response.json())
        .then(data => {
          this.informeInters = data;
        })
        .catch(error => {
          console.error('Error fetching informeInters:', error);
        });
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
    fetchDosiss() {
      fetch('http://localhost:8080/api/v1/dosiss')
        .then(response => response.json())
        .then(data => {
          this.dosiss = data;
        })
        .catch(error => {
          console.error('Error fetching dosiss:', error);
        });
    },
    fetchFrecuencias() {
      fetch('http://localhost:8080/api/v1/frecuencias')
        .then(response => response.json())
        .then(data => {
          this.frecuencias = data;
        })
        .catch(error => {
          console.error('Error fetching frecuencias:', error);
        });
    },
  },
}
</script>
